/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2018/12/5
 */
import {createProjectModelWarp} from 'utils/model'
import config from '../config'

export function createProjectModelNamespace(name) {
    return `${config.dvaNamespacePrefix}_${name}`
}

export const createProjectModel = createProjectModelWarp({createProjectModelNamespace})
